export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mapbox-gl-csp-worker-0f94dc3adf707595e1e9.worker.js");
}
